import {blacklistsettings} from './Blacklist/sl'
import {changeemailsettings} from './ChangeEmail/sl'
import {changepasswordsettings} from './ChangePassword/sl'
import {languagesettings} from './Language/sl'
import {settingsdropdown} from './SettingsDropdown/sl'
import {myAccount} from './MyAccount/sl'

export const settings = {
  ...languagesettings,
  ...changeemailsettings,
  ...changepasswordsettings,
  ...blacklistsettings,
  ...settingsdropdown,
  ...myAccount,
}
